import { render, staticRenderFns } from "./formSetting.vue?vue&type=template&id=6dcc9c5f&scoped=true&"
import script from "./formSetting.vue?vue&type=script&lang=js&"
export * from "./formSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcc9c5f",
  null
  
)

export default component.exports